<template>
  <div class="page-wrapper">
    <header class="site-header"></header>

    <main class="tutorial-container" id="tutorial">
      <h1 class="page-title">Tutorial Content</h1>
      <p class="course-info">
        {{ totalSections }} sections · {{ totalLectures }} tutorials · {{ totalDuration }} total length
      </p>

     
      <div v-for="(section, index) in sections" :key="index" class="section">
        <div class="section-header" @click="toggleSection(index)">
          <span>{{ section.title }}</span>
          <span>{{ section.lectures.length }} tutorials · {{ section.duration }} </span>
        </div>

        <transition name="fade">
          <ul v-show="section.open" class="lectures">
            <li v-for="(lecture, i) in section.lectures" :key="i">
              <span class="lecture-title">{{ lecture.title }}</span>
              <span class="lecture-duration">{{ lecture.time }}</span>
              <button
                v-if="lecture.preview"
                class="preview-btn"
                @click.stop="playVideo(lecture.videoUrl)"
              >
                ▶
              </button>

            </li>
          </ul>
        </transition>
      </div>

      
      <div v-if="showVideo" class="video-modal">
        <div class="video-content">
          <span class="close-btn" @click="closeVideo">&times;</span>
          <video controls autoplay>
            <source :src="currentVideo" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "TutorialPage",
  data() {
    return {
      showVideo: false,
      currentVideo: null,
      sections: [
        // {
          // title: "Introduction",
          // duration: "5m",
          // open: true,
          // lectures: [
          //   { title: "About Us", time: "02:00", preview: true, },
            //  videoUrl: require("@/assets/videos/About_Us.mp4") },
            // { title: "Login", time: "03:00", preview: true, },
            // videoUrl: require("@/assets/videos/Login.mp4") },
        //   ],
        // },
        {
          title: "Daily Operations",
          duration: "6m",
          open: false,
          lectures: [
            { title: "Bill Entry", time: "02:07", preview: true, videoUrl: require("@/assets/videos/Bill_Entry.mp4") },
            { title: "Balance Receipt", time: "00:40", preview: true, videoUrl: require("@/assets/videos/Balance_receipt.mp4") },
            { title: "Test Result", time: "01:39", preview: true, videoUrl: require("@/assets/videos/Test_Result.mp4") },
            { title: "Finance", time: "01:11", preview: true, videoUrl: require("@/assets/videos/Finance.mp4") },
          ],
        },
        {
          title: "Settings",
          duration: "8m",
          open: false,
          lectures: [
            { title: "Test Group", time: "00:54", preview: true, videoUrl: require("@/assets/videos/Test_Group.mp4") },
            { title: "Test Master", time: "01:07", preview: true, videoUrl: require("@/assets/videos/Test_master.mp4") },
            { title: "Test Parameter", time: "01:13", preview: true, videoUrl: require("@/assets/videos/Test_Parameter.mp4") },
            { title: "Test Interpretation", time: "00:46", preview: true, videoUrl: require("@/assets/videos/Test_Interpretation.mp4") },
            { title: "Packages", time: "01:46", preview: true, videoUrl: require("@/assets/videos/Packages.mp4") },
            { title: "Abnormal Validation", time: "01:18", preview: true, videoUrl: require("@/assets/videos/Abnormal_Validation.mp4") },
          ],
        },
        {
          title: "Advance",
          duration: "12m",
          open: false,
          lectures: [
            { title: "Test List Configuration", time: "01:06", preview: true, videoUrl: require("@/assets/videos/Test_List_Configuration.mp4") },
            { title: "WhatsApp Report", time: "01:20", preview: true, },
            // videoUrl: require("@/assets/videos/WhatsApp_Report.mp4") },
            { title: "Report History Compare", time: "01:45", preview: true, },
            // videoUrl: require("@/assets/videos/Report_History_Compare.mp4") },
            { title: "Customer Ledger", time: "01:30", preview: true, },
            // videoUrl: require("@/assets/videos/Customer_Ledger.mp4") },
            { title: "Machine Integration", time: "02:10", preview: true,}, 
            // videoUrl: require("@/assets/videos/Machine_Integration.mp4") },
            { title: "Approval System", time: "02:05", preview: true, },
            // videoUrl: require("@/assets/videos/Approval_System.mp4") },
            { title: "User-Based Privilege", time: "02:15", preview: true,}, 
            // videoUrl: require("@/assets/videos/User_Based_Privilege.mp4") },
          ],
        },
      ],
    };
  },
  computed: {
    totalSections() {
      return this.sections.length;
    },
    totalLectures() {
      return this.sections.reduce((sum, s) => sum + s.lectures.length, 0);
    },
    totalDuration() {
      let totalSeconds = 0;
      this.sections.forEach((section) => {
        section.lectures.forEach((lec) => {
          const [min, sec] = lec.time.split(":").map(Number);
          totalSeconds += min * 60 + sec;
        });
      });

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
      } else {
        return `${minutes}m ${seconds}s`;
      }
    },
  },
  methods: {
    toggleSection(index) {
      this.sections[index].open = !this.sections[index].open;
    },
    playVideo(url) {
      this.currentVideo = url;
      this.showVideo = true;
    },
    closeVideo() {
      this.showVideo = false;
      this.currentVideo = null;
    },
  },
};
</script>

<style scoped>
/* --- keep your styles same as before (no change needed) --- */
</style>

<style scoped>
.page-wrapper {
  display:block;
  flex-direction: column;
  min-height: 100vh;
}
.site-header {
  background-color: #206A98;
  color: white;
  text-align: center;
  padding: 15px;
  font-size: 24px;
  font-weight: bold;
}

 .tutorial-container {
  flex: 1;
  max-width: 900px;
  margin: auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 5px;
  text-align: center;
  color: #206A98;
}

.course-info {
  color: #666;
  margin-bottom: 20px;
}

.actions {
  margin-bottom: 15px;
}
.btn {
  margin-right: 10px;
  padding: 6px 12px;
  border: none;
  background-color: #206A98;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}
.btn:hover {
  background-color: #206A98;
}

.section {
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-bottom: 12px;
  overflow: hidden;
}
.section-header {
  background: #f7f7f7;
  padding: 12px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.section-header:hover {
  background: #eee;
}

.lectures {
  list-style: none;
  margin: 0;
  padding: 10px 15px;
}
.lectures li {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px solid #eee;
  align-items: center;
}
.lectures li:last-child {
  border-bottom: none;
}

.lecture-title {
  flex: 1;
}
.lecture-duration {
  margin-left: 10px;
  color: #555;
  font-size: 14px;
}

.preview-btn {
  margin-left: 10px;
  background-color: #206A98;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 3px 5px;
  font-size: 10px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.preview-btn:hover {
  background-color: #174d70;
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}


.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
.video-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  max-width: 800px;
  width: 90%;
}
.video-content video {
  width: 100%;
  border-radius: 6px;
}
.close-btn {
  position: absolute;
  top: 8px;
  right: 12px;
  font-size: 24px;
  cursor: pointer;
  color: #333;
}
/* Tablet view (≤768px) */
@media (max-width: 768px) {
  .page-title {
    font-size: 24px;
  }

  .btn {
    margin: 5px;
    padding: 8px 12px;
    font-size: 14px;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .lectures li {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

/* Mobile view (≤480px) */
@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .course-info {
    font-size: 14px;
  }

  .btn {
    width: 100%;
    margin-bottom: 10px;
    padding: 10px;
    font-size: 14px;
  }

  .section-header {
    padding: 10px;
    font-size: 16px;
  }

  .lecture-title,
  .lecture-duration,
  .preview-link {
    font-size: 13px;
  }

  .video-content {
    width: 50%;
    padding: 5px;
  }
}
</style> 

